var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-container"},[_c('div',{staticClass:"item-main"},[_c('div',{staticClass:"item-title"},[_vm._m(0),_c('span',[_vm._v(_vm._s(_vm.item.title.toUpperCase()))])])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"material-icons vtd-icon-4 vtd-mr-3 vtd-align-middle"},[_c('span',[_vm._v("")])])
}]

export { render, staticRenderFns }